import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

export const getStudyAnalyses = asyncThunkWrapper({ 
  model: 'studyAnalyses', 
  action: 'getStudyAnalyses', 
  func: async ({ offset = 0 }) => {
    const attributes = ['id', 'status', 'updated_at'];
    const params = { limit: 25, offset, orders: { updated_at: 'desc' }, attributes };
    const response = await axios.get('/study_flow/study_analyses', { params });

    return response.data;
  } 
});
export const getStudyAnalysis = asyncThunkWrapper({ 
  model: 'studyAnalyses', 
  action: 'getStudyAnalysis', 
  func: async ({ id, cable = false }) => {
    const attributes = ['id', 'status', 'updated_at'];
    const params = { attributes };
    const response = await axios.get(`/study_analyses/${id}`, { params });

    return { data: response.data, cable };
  } 
});
export const createStudyAnalysis = asyncThunkWrapper({ 
  model: 'studyAnalyses', 
  action: 'createStudyAnalysis', 
  func: async () => {
    const attributes = ['id', 'status', 'updated_at'];
    const response = await axios.post(`/study_flow/study_analyses`, { attributes });

    return response.data;
  } 
});
export const clearLocalStudyAnalyses = createAction('studyAnalyses/clearLocalStudyAnalyses');
export const clearLocalActiveStudyAnalysis = createAction('studyAnalyses/clearLocalActiveStudyAnalysis');